
import {Component, OnInit, ViewChild} from '@angular/core';
import {AccountService} from "../account.service";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {ShowHideInput} from "../../shared/change-input.directive";
import {NotificationBarService} from "../../core/notify/notification.service";
import {NotificationType} from "../../core/notify/index";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild(ShowHideInput) input: ShowHideInput;
   passwordForm: FormGroup;
   isSubmitted;
   isLoading;
  constructor(private  accountService: AccountService,
              private fb: FormBuilder,
              private notifier: NotificationBarService) { }



  ngOnInit() {
    this.buildForm();
  }

  changePassword(form){
    this.isSubmitted = true;
    this.onValueChanged();
    if(form.valid){
      this.isLoading = true;
      this.accountService.updatePassword(form.value)
        .subscribe((response) =>{
            this.isLoading = false;
            this.notifier.create({message:response.status.message,type:NotificationType.Success});
            this.passwordForm.reset();
            this.isSubmitted = false;
      },
          (error)=>{
            this.notifier.create({message:error,type:NotificationType.Error});
            this.isLoading = false
      });
    }

  }

  buildForm(){
    this.passwordForm = this.fb.group({
      'currentPassword':['',[
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20)

      ]],
      'newPassword':['',[
        Validators.required,
       // Validators.pattern(/((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.))/),
        Validators.minLength(5),
        Validators.maxLength(20)


      ]]
    })
    this.passwordForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();


  }
  onValueChanged(data?: any){
    if (!this.passwordForm) { return; }
    const form = this.passwordForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid || this.isSubmitted)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  formErrors = {
    'currentPassword': '',
    'newPassword':''
  };
  validationMessages = {
    'currentPassword': {
      'required':  'REGISTRATION.VALIDATIONS.PASSWORD.REQUIRED',
      'minlength':'REGISTRATION.VALIDATIONS.PASSWORD.MIN_LENGTH',
      'pattern':'REGISTRATION.VALIDATIONS.PASSWORD.ALPHA_NUMERIC',
      'maxlength':'REGISTRATION.VALIDATIONS.PASSWORD.MAX_LENGTH',
    },
    'newPassword':{
      'required':'REGISTRATION.VALIDATIONS.PASSWORD.REQUIRED',
      'minlength':'REGISTRATION.VALIDATIONS.PASSWORD.MIN_LENGTH',
      'maxlength':'REGISTRATION.VALIDATIONS.PASSWORD.MAX_LENGTH',
      'pattern':'REGISTRATION.VALIDATIONS.PASSWORD.ALPHA_NUMERIC'
    }
  };
  togglePassword(isChecked: boolean){
    if(isChecked)
      this.input.changeType("text");
    else
      this.input.changeType("password");

  }

}



// WEBPACK FOOTER //
// ./src/app/accounts/change-password/change-password.component.ts